module.exports = __webpack_public_path__ + "img/event_back_1.2c08552a.jpg";